/**
 * Loading State Slice
 * Manages global loading state for async operations
 */

import create from 'zustand';
import type { LoadingState } from '../../types';

export const useLoadingStore = create<LoadingState>((set) => ({
  loading: false,
  setLoading: (loading) => set({ loading }),
}));

// Maintain backward compatibility
export default useLoadingStore;
